<div class="form-header">
  Reset your Identify password below.
</div>
<form class="form-field-list" [formGroup]="form" style="width:100%;">
  <div *ngIf="loggedInDirectly" >
    <div>
      <mat-form-field>
        <input type="password" matInput placeholder="Current Password" formControlName="currentPassword" required>
        <mat-error *ngIf="form.controls.currentPassword?.errors?.incorrectPassword">Does not match your current password</mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <input type="password" matInput placeholder="New Password" formControlName="newPassword" required pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$">
        <mat-hint>at least 8 characters, 1 uppercase, 1 lowercase, 1 number, and 1 special character</mat-hint>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <input type="password" matInput placeholder="Confirm New Password" formControlName="confirmNewPassword" required>
        <mat-error *ngIf="form.controls.confirmNewPassword?.errors?.passwordNoMatch">Doesn't match new password</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="!loggedInDirectly">
    You must be logged in with your Identify username to update direct login settings.
  </div>
</form>